import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const UpsideDownStar = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7802)">
      <path d="M16 28.9238L18.9187 19.941H28.3637L20.7225 14.3894L23.6412 5.40661L16 10.9583L8.35879 5.40661L11.2775 14.3894L3.63627 19.941H13.0813L16 28.9238Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7802">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'UpsideDownStar'
);
